export default "__VITE_ASSET__C9o3pBwd__"